// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════════════════
   MODO TABLET — inventariar el rack con el dedo
   ───────────────────────────────────────────────────────────────────────────
   Se activa con puntero grueso (o con el botón 📱 de la cabecera) y cambia la
   forma de trabajar, no solo el tamaño:

   · una CARA cada vez (frontal o trasera) — tres columnas no caben;
   · tocar un equipo abre su ficha en una hoja inferior con acciones grandes;
   · tocar un hueco libre abre el alta rápida EN ESA U;
   · «Mover a otra U» resalta los huecos válidos y se coloca con un toque.

   El modo escritorio no cambia: todo esto vive detrás de \`.rv--touch\`.
   ═══════════════════════════════════════════════════════════════════════════ */

.rv--touch .rack-viewer-grid {
  grid-template-columns: minmax(0, 1fr);
  /* En la tablet solo se pinta el tablero: una fila con todo el alto (la regla
     de escritorio parte en dos filas y dejaría un hueco muerto arriba). */
  grid-template-rows: minmax(0, 1fr);
  padding: 0;
  gap: 8px;
}
/* En modo tablet el panel de pendientes y el lateral son hojas, no columnas.
   OJO: NO ocultar \`.rack-side\` con un selector de más especificidad que
   \`.rv-sheet-side.is-open\`, o la hoja no abriría en pantallas anchas (>1180 px).
   El que la esconde cuando está cerrada es \`.rv-sheet-side { display: none }\`. */
.rv--touch .rack-viewer-grid > .rack-unplaced {
  display: none;
}
.rv--touch .rack-dual {
  grid-template-columns: minmax(0, 1fr);
  /* Una sola fila útil: la barra de accesorios y la cara activa. */
  grid-template-rows: auto minmax(0, 1fr);
  row-gap: 8px;
}
/* Pantalla completa + tablet: el rail no se pinta, así que no hay barras dentro
   del rack y la cara activa se queda con todo el alto. */
.rv--fullscreen.rv--touch .rack-dual {
  grid-template-rows: minmax(0, 1fr);
}
.rv--touch .rack-panel--duct {
  display: none;
}
.rv--touch .rack-columns {
  /* El alto lo reparte el flex: cabecera + pestañas + barra inferior. */
  max-height: none;
  min-height: 140px;
}
.rv--touch .rack-viewer-container {
  /* A sangre: el alto lo reparte el layout, sin mínimo que desborde la tablet. */
  min-height: 0;
}
.rv--touch .rv-header {
  padding: 6px 12px;
  gap: 8px;
  flex-wrap: wrap;
}
.rv--touch .rv-rack-desc {
  display: none;
}
.rv--touch .rv-rack-name {
  font-size: 1.05rem;
}
.rv--touch .rv-layer-switch button {
  min-height: 40px;
  padding: 7px 14px;
  font-size: 0.84rem;
}
.rv--touch .rack-slot {
  cursor: pointer;
}

/* Pantalla completa en modo tablet: una sola columna (el rail no se pinta). */
.rv--fullscreen.rv--touch .rack-viewer-grid {
  grid-template-columns: minmax(0, 1fr);
}
.rv--touch .rv-rail {
  display: none;
}

/* ── Pestañas de cara ─────────────────────────────────────────────────────── */
.rv-face-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px 8px;
  flex-shrink: 0;
}
.rv-face-tabs button {
  min-height: 42px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  font-weight: 700;
  font-size: 0.86rem;
  cursor: pointer;
}
.rv-face-tabs button.is-on {
  background: color-mix(in srgb, var(--accent, #3b82f6) 18%, var(--bg-card));
  border-color: var(--accent, #3b82f6);
  color: var(--text-primary);
}
.rv-face-tabs em {
  font-style: normal;
  font-weight: 600;
  opacity: 0.72;
  margin-left: 6px;
}
.rv-face-hint {
  margin-left: auto;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-muted);
  white-space: nowrap;
}

/* ── Barra de «toca la U donde va» ────────────────────────────────────────── */
.rv-place-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 12px 8px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #22c55e;
  background: rgba(34, 197, 94, 0.14);
  color: var(--text-primary);
  font-size: 0.82rem;
  flex-shrink: 0;
}
.rv-place-bar span {
  flex: 1 1;
  min-width: 0;
}
.rv-place-bar button {
  min-height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-primary);
  font-weight: 600;
  cursor: pointer;
}

/* ── Huecos válidos al colocar ────────────────────────────────────────────── */
.rack-slot--target {
  background: rgba(34, 197, 94, 0.16);
  border-color: #22c55e !important;
  box-shadow: inset 0 0 0 1px rgba(34, 197, 94, 0.55);
  cursor: pointer;
}
.rack-slot-plus {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #22c55e;
  font-size: 1rem;
  font-weight: 800;
  pointer-events: none;
  z-index: 2;
}

/* ── Barra inferior de acciones ───────────────────────────────────────────── */
.rv-touch-dock {
  display: flex;
  gap: 8px;
  padding: 8px 10px calc(8px + env(safe-area-inset-bottom, 0px));
  border-top: 1px solid var(--border);
  background: var(--bg-toolbar);
  flex-shrink: 0;
}
.rv-touch-dock button {
  flex: 1 1;
  min-height: 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg-card);
  color: var(--text-primary);
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
}
.rv-touch-dock button span {
  font-size: 0.66rem;
  font-weight: 600;
  color: var(--text-muted);
}
.rv-touch-dock button.is-on {
  border-color: var(--accent, #3b82f6);
  background: color-mix(in srgb, var(--accent, #3b82f6) 14%, var(--bg-card));
}
.rv-touch-dock button:disabled {
  opacity: 0.45;
}

/* ── Hojas inferiores (ficha, pendientes, alta) ───────────────────────────── */
.rv-sheet-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1180;
  background: rgba(2, 6, 23, 0.55);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.rv-sheet,
.rv-sheet-side {
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: min(560px, 100%);
  max-height: 82dvh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--bg-surface, var(--bg-card));
  border: 1px solid var(--border);
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.42);
  z-index: 1190;
  padding-bottom: env(safe-area-inset-bottom, 0px);
}
.rv-sheet-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--text-primary);
}
.rv-sheet-close {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-primary);
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
}
.rv-sheet-body {
  padding: 12px 16px 20px;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

/* El panel lateral de escritorio convertido en hoja: mismo contenido, otra caja. */
.rv-sheet-side {
  display: none;
}
.rv-sheet-side.is-open {
  display: flex;
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: min(560px, 100%);
  max-height: 82dvh;
  padding: 0;
  border-radius: 16px 16px 0 0;
  border: 1px solid var(--border);
  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.42);
  z-index: 1190;
  overflow-y: auto;
  overscroll-behavior: contain;
}
/* \`@media (max-width: 1180px)\` esconde \`.rack-side\` con \`display:none\`; la hoja
   abierta tiene que ganarle. */
@media (max-width: 1180px) {
  .rack-viewer-grid > .rack-side.rv-sheet-side.is-open {
    display: flex;
  }
}

.rv-sheet--unplaced {
  height: auto;
  max-height: 82dvh;
}
.rv-sheet--unplaced .rack-unplaced {
  border: 0;
  border-radius: 0;
  background: transparent;
  max-height: none;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 10px 14px 16px;
}

.rv-sheet-sub {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-muted);
  margin: 2px 0 8px;
}
.rv-sheet-note {
  margin: 12px 0 0;
  font-size: 0.74rem;
  line-height: 1.45;
  color: var(--text-muted);
}
.rv-type-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.rv-type-grid button {
  min-height: 62px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-primary);
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
}
.rv-type-grid button span {
  font-size: 1.25rem;
  line-height: 1;
}
.rv-type-grid button.is-on {
  border-color: var(--accent, #3b82f6);
  background: color-mix(in srgb, var(--accent, #3b82f6) 16%, var(--bg-card));
}
.rv-big-btn {
  width: 100%;
  min-height: 52px;
  margin-bottom: 14px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 700;
  cursor: pointer;
}
.rv-big-btn.is-primary {
  background: color-mix(in srgb, #22c55e 16%, var(--bg-card));
  border-color: #22c55e;
}

/* ── Acciones del equipo seleccionado (dentro de la hoja) ─────────────────── */
.rv-touch-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 12px 16px 4px;
}
.rv-touch-actions button {
  min-height: 48px;
  border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-primary);
  font-size: 0.84rem;
  font-weight: 600;
  cursor: pointer;
}
.rv-touch-actions button.is-primary {
  background: color-mix(in srgb, #22c55e 16%, var(--bg-card));
  border-color: #22c55e;
}
.rv-touch-actions button.is-danger {
  background: rgba(239, 68, 68, 0.14);
  border-color: rgba(239, 68, 68, 0.45);
  color: #fca5a5;
}
.rv-touch-actions button:disabled {
  opacity: 0.5;
}

/* ── Ajustes globales para dedo ───────────────────────────────────────────── */
@media (pointer: coarse) {
  .rack-add-btn,
  .rack-filler-btn {
    min-height: 40px;
    font-size: 0.8rem;
  }
  /* iOS hace zoom automático al enfocar un campo de menos de 16 px. */
  .rqc-dialog :is(input, select, textarea),
  .list-dialog :is(input, select, textarea) {
    font-size: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RackViewerTouch.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;gFAYgF;;AAEhF;EACE,qCAAqC;EACrC;0EACwE;EACxE,kCAAkC;EAClC,UAAU;EACV,QAAQ;AACV;AACA;;;iFAGiF;AACjF;EACE,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,iEAAiE;EACjE,uCAAuC;EACvC,YAAY;AACd;AACA;yDACyD;AACzD;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,sEAAsE;EACtE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,+EAA+E;EAC/E,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,0EAA0E;EAC1E,oCAAoC;EACpC,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mCAAmC;EACnC,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gFAAgF;AAChF;EACE,mCAAmC;EACnC,gCAAgC;EAChC,mDAAmD;EACnD,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,QAAQ;EACR,8DAA8D;EAC9D,mCAAmC;EACnC,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,0EAA0E;AAC5E;AACA;EACE,aAAa;AACf;;AAEA,gFAAgF;AAChF;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;AACA;;EAEE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,6CAA6C;EAC7C,+BAA+B;EAC/B,4BAA4B;EAC5B,4CAA4C;EAC5C,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,mFAAmF;AACnF;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,4BAA4B;EAC5B,+BAA+B;EAC/B,4CAA4C;EAC5C,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;+BAC+B;AAC/B;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,0EAA0E;AAC5E;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA,gFAAgF;AAChF;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2DAA2D;EAC3D,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;AACA;EACE,YAAY;AACd;;AAEA,gFAAgF;AAChF;EACE;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;EACA,oEAAoE;EACpE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════════════════════════════\r\n   MODO TABLET — inventariar el rack con el dedo\r\n   ───────────────────────────────────────────────────────────────────────────\r\n   Se activa con puntero grueso (o con el botón 📱 de la cabecera) y cambia la\r\n   forma de trabajar, no solo el tamaño:\r\n\r\n   · una CARA cada vez (frontal o trasera) — tres columnas no caben;\r\n   · tocar un equipo abre su ficha en una hoja inferior con acciones grandes;\r\n   · tocar un hueco libre abre el alta rápida EN ESA U;\r\n   · «Mover a otra U» resalta los huecos válidos y se coloca con un toque.\r\n\r\n   El modo escritorio no cambia: todo esto vive detrás de `.rv--touch`.\r\n   ═══════════════════════════════════════════════════════════════════════════ */\r\n\r\n.rv--touch .rack-viewer-grid {\r\n  grid-template-columns: minmax(0, 1fr);\r\n  /* En la tablet solo se pinta el tablero: una fila con todo el alto (la regla\r\n     de escritorio parte en dos filas y dejaría un hueco muerto arriba). */\r\n  grid-template-rows: minmax(0, 1fr);\r\n  padding: 0;\r\n  gap: 8px;\r\n}\r\n/* En modo tablet el panel de pendientes y el lateral son hojas, no columnas.\r\n   OJO: NO ocultar `.rack-side` con un selector de más especificidad que\r\n   `.rv-sheet-side.is-open`, o la hoja no abriría en pantallas anchas (>1180 px).\r\n   El que la esconde cuando está cerrada es `.rv-sheet-side { display: none }`. */\r\n.rv--touch .rack-viewer-grid > .rack-unplaced {\r\n  display: none;\r\n}\r\n.rv--touch .rack-dual {\r\n  grid-template-columns: minmax(0, 1fr);\r\n  /* Una sola fila útil: la barra de accesorios y la cara activa. */\r\n  grid-template-rows: auto minmax(0, 1fr);\r\n  row-gap: 8px;\r\n}\r\n/* Pantalla completa + tablet: el rail no se pinta, así que no hay barras dentro\r\n   del rack y la cara activa se queda con todo el alto. */\r\n.rv--fullscreen.rv--touch .rack-dual {\r\n  grid-template-rows: minmax(0, 1fr);\r\n}\r\n.rv--touch .rack-panel--duct {\r\n  display: none;\r\n}\r\n.rv--touch .rack-columns {\r\n  /* El alto lo reparte el flex: cabecera + pestañas + barra inferior. */\r\n  max-height: none;\r\n  min-height: 140px;\r\n}\r\n.rv--touch .rack-viewer-container {\r\n  /* A sangre: el alto lo reparte el layout, sin mínimo que desborde la tablet. */\r\n  min-height: 0;\r\n}\r\n.rv--touch .rv-header {\r\n  padding: 6px 12px;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n.rv--touch .rv-rack-desc {\r\n  display: none;\r\n}\r\n.rv--touch .rv-rack-name {\r\n  font-size: 1.05rem;\r\n}\r\n.rv--touch .rv-layer-switch button {\r\n  min-height: 40px;\r\n  padding: 7px 14px;\r\n  font-size: 0.84rem;\r\n}\r\n.rv--touch .rack-slot {\r\n  cursor: pointer;\r\n}\r\n\r\n/* Pantalla completa en modo tablet: una sola columna (el rail no se pinta). */\r\n.rv--fullscreen.rv--touch .rack-viewer-grid {\r\n  grid-template-columns: minmax(0, 1fr);\r\n}\r\n.rv--touch .rv-rail {\r\n  display: none;\r\n}\r\n\r\n/* ── Pestañas de cara ─────────────────────────────────────────────────────── */\r\n.rv-face-tabs {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 0 12px 8px;\r\n  flex-shrink: 0;\r\n}\r\n.rv-face-tabs button {\r\n  min-height: 42px;\r\n  padding: 0 16px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  font-weight: 700;\r\n  font-size: 0.86rem;\r\n  cursor: pointer;\r\n}\r\n.rv-face-tabs button.is-on {\r\n  background: color-mix(in srgb, var(--accent, #3b82f6) 18%, var(--bg-card));\r\n  border-color: var(--accent, #3b82f6);\r\n  color: var(--text-primary);\r\n}\r\n.rv-face-tabs em {\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  opacity: 0.72;\r\n  margin-left: 6px;\r\n}\r\n.rv-face-hint {\r\n  margin-left: auto;\r\n  font-size: 0.72rem;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Barra de «toca la U donde va» ────────────────────────────────────────── */\r\n.rv-place-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  margin: 0 12px 8px;\r\n  padding: 8px 12px;\r\n  border-radius: 10px;\r\n  border: 1px solid #22c55e;\r\n  background: rgba(34, 197, 94, 0.14);\r\n  color: var(--text-primary);\r\n  font-size: 0.82rem;\r\n  flex-shrink: 0;\r\n}\r\n.rv-place-bar span {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n.rv-place-bar button {\r\n  min-height: 36px;\r\n  padding: 0 14px;\r\n  border-radius: 8px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-primary);\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n/* ── Huecos válidos al colocar ────────────────────────────────────────────── */\r\n.rack-slot--target {\r\n  background: rgba(34, 197, 94, 0.16);\r\n  border-color: #22c55e !important;\r\n  box-shadow: inset 0 0 0 1px rgba(34, 197, 94, 0.55);\r\n  cursor: pointer;\r\n}\r\n.rack-slot-plus {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #22c55e;\r\n  font-size: 1rem;\r\n  font-weight: 800;\r\n  pointer-events: none;\r\n  z-index: 2;\r\n}\r\n\r\n/* ── Barra inferior de acciones ───────────────────────────────────────────── */\r\n.rv-touch-dock {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 8px 10px calc(8px + env(safe-area-inset-bottom, 0px));\r\n  border-top: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  flex-shrink: 0;\r\n}\r\n.rv-touch-dock button {\r\n  flex: 1;\r\n  min-height: 52px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  color: var(--text-primary);\r\n  font-size: 1.05rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n.rv-touch-dock button span {\r\n  font-size: 0.66rem;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n}\r\n.rv-touch-dock button.is-on {\r\n  border-color: var(--accent, #3b82f6);\r\n  background: color-mix(in srgb, var(--accent, #3b82f6) 14%, var(--bg-card));\r\n}\r\n.rv-touch-dock button:disabled {\r\n  opacity: 0.45;\r\n}\r\n\r\n/* ── Hojas inferiores (ficha, pendientes, alta) ───────────────────────────── */\r\n.rv-sheet-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1180;\r\n  background: rgba(2, 6, 23, 0.55);\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: center;\r\n}\r\n.rv-sheet,\r\n.rv-sheet-side {\r\n  position: fixed;\r\n  left: 50%;\r\n  bottom: 0;\r\n  transform: translateX(-50%);\r\n  width: min(560px, 100%);\r\n  max-height: 82dvh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  background: var(--bg-surface, var(--bg-card));\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px 16px 0 0;\r\n  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.42);\r\n  z-index: 1190;\r\n  padding-bottom: env(safe-area-inset-bottom, 0px);\r\n}\r\n.rv-sheet-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid var(--border);\r\n  font-weight: 700;\r\n  font-size: 0.95rem;\r\n  color: var(--text-primary);\r\n}\r\n.rv-sheet-close {\r\n  width: 40px;\r\n  height: 40px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n.rv-sheet-body {\r\n  padding: 12px 16px 20px;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n/* El panel lateral de escritorio convertido en hoja: mismo contenido, otra caja. */\r\n.rv-sheet-side {\r\n  display: none;\r\n}\r\n.rv-sheet-side.is-open {\r\n  display: flex;\r\n  position: fixed;\r\n  left: 50%;\r\n  bottom: 0;\r\n  transform: translateX(-50%);\r\n  width: min(560px, 100%);\r\n  max-height: 82dvh;\r\n  padding: 0;\r\n  border-radius: 16px 16px 0 0;\r\n  border: 1px solid var(--border);\r\n  box-shadow: 0 -12px 40px rgba(0, 0, 0, 0.42);\r\n  z-index: 1190;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n/* `@media (max-width: 1180px)` esconde `.rack-side` con `display:none`; la hoja\r\n   abierta tiene que ganarle. */\r\n@media (max-width: 1180px) {\r\n  .rack-viewer-grid > .rack-side.rv-sheet-side.is-open {\r\n    display: flex;\r\n  }\r\n}\r\n\r\n.rv-sheet--unplaced {\r\n  height: auto;\r\n  max-height: 82dvh;\r\n}\r\n.rv-sheet--unplaced .rack-unplaced {\r\n  border: 0;\r\n  border-radius: 0;\r\n  background: transparent;\r\n  max-height: none;\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  padding: 10px 14px 16px;\r\n}\r\n\r\n.rv-sheet-sub {\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  color: var(--text-muted);\r\n  margin: 2px 0 8px;\r\n}\r\n.rv-sheet-note {\r\n  margin: 12px 0 0;\r\n  font-size: 0.74rem;\r\n  line-height: 1.45;\r\n  color: var(--text-muted);\r\n}\r\n.rv-type-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 10px;\r\n}\r\n.rv-type-grid button {\r\n  min-height: 62px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 3px;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n  font-size: 0.84rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n.rv-type-grid button span {\r\n  font-size: 1.25rem;\r\n  line-height: 1;\r\n}\r\n.rv-type-grid button.is-on {\r\n  border-color: var(--accent, #3b82f6);\r\n  background: color-mix(in srgb, var(--accent, #3b82f6) 16%, var(--bg-card));\r\n}\r\n.rv-big-btn {\r\n  width: 100%;\r\n  min-height: 52px;\r\n  margin-bottom: 14px;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n  font-size: 0.9rem;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n}\r\n.rv-big-btn.is-primary {\r\n  background: color-mix(in srgb, #22c55e 16%, var(--bg-card));\r\n  border-color: #22c55e;\r\n}\r\n\r\n/* ── Acciones del equipo seleccionado (dentro de la hoja) ─────────────────── */\r\n.rv-touch-actions {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 8px;\r\n  padding: 12px 16px 4px;\r\n}\r\n.rv-touch-actions button {\r\n  min-height: 48px;\r\n  border-radius: 10px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n  font-size: 0.84rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n.rv-touch-actions button.is-primary {\r\n  background: color-mix(in srgb, #22c55e 16%, var(--bg-card));\r\n  border-color: #22c55e;\r\n}\r\n.rv-touch-actions button.is-danger {\r\n  background: rgba(239, 68, 68, 0.14);\r\n  border-color: rgba(239, 68, 68, 0.45);\r\n  color: #fca5a5;\r\n}\r\n.rv-touch-actions button:disabled {\r\n  opacity: 0.5;\r\n}\r\n\r\n/* ── Ajustes globales para dedo ───────────────────────────────────────────── */\r\n@media (pointer: coarse) {\r\n  .rack-add-btn,\r\n  .rack-filler-btn {\r\n    min-height: 40px;\r\n    font-size: 0.8rem;\r\n  }\r\n  /* iOS hace zoom automático al enfocar un campo de menos de 16 px. */\r\n  .rqc-dialog :is(input, select, textarea),\r\n  .list-dialog :is(input, select, textarea) {\r\n    font-size: 16px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
